import Header from "@/pages/components/Header";
import Footer from "@/pages/components/Footer";
import { heroImage } from "@/mocks/manhwaData";

const principles = [
  {
    icon: "ri-verified-badge-line",
    title: "坚持正版",
    desc: "只收录获得正式授权的韩漫内容，尊重每一位创作者的心血，拒绝盗版与侵权资源。",
  },
  {
    icon: "ri-aliens-line",
    title: "题材聚合",
    desc: "从甜宠到悬疑、从奇幻到现实，八大核心题材持续扩充，让不同类型爱好者各取所需。",
  },
  {
    icon: "ri-bar-chart-line",
    title: "数据真实",
    desc: "人气榜单依据真实阅读数据综合排序，让真正优秀的内容被更多人看见。",
  },
  {
    icon: "ri-heart-3-line",
    title: "读者为本",
    desc: "以读者的阅读体验为核心，持续优化分类与推荐，帮助大家告别选择困难。",
  },
];

const testimonials = [
  {
    name: "小葵",
    role: "甜宠爱好者",
    avatar: "https://readdy.ai/api/search-image?query=cute%20anime%20girl%20avatar%20soft%20warm%20cream%20background%20friendly%20smile%20pastel%20coral%20tones%20flat%20illustration%20high%20quality&width=200&height=200&seq=avatar-1&orientation=squarish",
    text: "分类很清晰，甜宠类目更新快，编辑推荐的作品几乎都合我胃口，每周必来逛榜单。",
  },
  {
    name: "阿哲",
    role: "悬疑推理迷",
    avatar: "https://readdy.ai/api/search-image?query=cool%20anime%20boy%20avatar%20warm%20neutral%20background%20thoughtful%20expression%20terracotta%20tones%20flat%20illustration%20high%20quality&width=200&height=200&seq=avatar-2&orientation=squarish",
    text: "悬疑榜单很对我的口味，追更状态和章节数标得清清楚楚，再也不会追到一半才发现断更。",
  },
  {
    name: "Momo",
    role: "治愈日常党",
    avatar: "https://readdy.ai/api/search-image?query=gentle%20anime%20girl%20avatar%20soft%20cream%20background%20kind%20smile%20warm%20amber%20tones%20flat%20illustration%20high%20quality&width=200&height=200&seq=avatar-3&orientation=squarish",
    text: "在这里找到了好多治愈日常的宝藏作品，页面很清爽，推荐的题材也经常给我惊喜。",
  },
];

export default function About() {
  return (
    <>
      <Header />

      <main>
        {/* Hero */}
        <section className="relative flex w-full items-center overflow-hidden">
          <img
            src={heroImage}
            alt="正版韩漫大全关于我们背景插画"
            title="正版韩漫大全 · 关于我们"
            className="absolute inset-0 h-full w-full object-cover object-center"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/45 to-black/60"></div>
          <div className="relative z-10 mx-auto w-full max-w-7xl px-4 py-20 md:px-6 md:py-28">
            <nav aria-label="面包屑导航" className="mb-6">
              <ol className="flex flex-wrap items-center gap-2 text-sm text-background-100/80">
                <li>
                  <a href="/" className="transition-colors hover:text-background-50">
                    首页
                  </a>
                </li>
                <li>
                  <i className="ri-arrow-right-s-line"></i>
                </li>
                <li aria-current="page" className="text-background-50">
                  关于我们
                </li>
              </ol>
            </nav>
            <h1 className="max-w-3xl font-heading text-3xl leading-tight text-background-50 md:text-5xl md:leading-tight">
              让每一部正版韩漫，都被热爱它的人看见
            </h1>
            <p className="mt-5 max-w-2xl text-sm leading-relaxed text-background-100/90 md:text-base">
              正版韩漫大全是一个以题材分类与人气榜单为核心的韩漫聚合平台，致力于帮读者在浩瀚的作品海洋里快速找到心头好。
            </p>
          </div>
        </section>

        {/* Positioning & intro */}
        <section className="mx-auto w-full max-w-7xl px-4 py-14 md:px-6 md:py-20">
          <div className="grid grid-cols-1 gap-10 lg:grid-cols-2 lg:items-center">
            <div>
              <span className="inline-flex items-center gap-1.5 rounded-full bg-primary-100 px-3 py-1 text-xs font-medium text-primary-700">
                <i className="ri-compass-3-line"></i>
                网站定位
              </span>
              <h2 className="mt-3 font-heading text-2xl text-foreground-950 md:text-3xl">
                题材分类聚合，人气推荐一页全览
              </h2>
              <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
                我们相信，看一部好作品不该先被找作品难住。正版韩漫大全从读者的真实痛点出发，将散落在各处的韩漫按照甜宠、奇幻、悬疑、热血、治愈等题材系统梳理，并用人气榜单与编辑推荐帮助大家快速定位。
              </p>
              <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
                无论是想追一部高分口碑之作，还是想换换口味探索新题材，你都能在这里找到方向，从此告别面对海量作品却无从下手的迷茫。
              </p>
              <div className="mt-6 flex flex-wrap gap-3">
                <span className="rounded-full bg-secondary-100 px-4 py-1.5 text-xs text-secondary-900">题材聚合</span>
                <span className="rounded-full bg-secondary-100 px-4 py-1.5 text-xs text-secondary-900">人气榜单</span>
                <span className="rounded-full bg-secondary-100 px-4 py-1.5 text-xs text-secondary-900">正版推荐</span>
              </div>
            </div>
            <div className="grid grid-cols-2 gap-4">
              <div className="rounded-2xl bg-primary-500 p-5 md:p-6">
                <p className="font-heading text-3xl text-background-50 md:text-4xl">760+</p>
                <p className="mt-2 text-xs text-background-100/90">收录正版韩漫作品</p>
              </div>
              <div className="rounded-2xl bg-accent-500 p-5 md:p-6">
                <p className="font-heading text-3xl text-background-50 md:text-4xl">8</p>
                <p className="mt-2 text-xs text-background-100/90">核心题材分类</p>
              </div>
              <div className="rounded-2xl bg-secondary-500 p-5 md:p-6">
                <p className="font-heading text-3xl text-background-50 md:text-4xl">24h</p>
                <p className="mt-2 text-xs text-background-100/90">榜单实时更新</p>
              </div>
              <div className="rounded-2xl bg-background-100 p-5 md:p-6">
                <p className="font-heading text-3xl text-primary-600 md:text-4xl">100%</p>
                <p className="mt-2 text-xs text-foreground-600">坚持正版授权</p>
              </div>
            </div>
          </div>
        </section>

        {/* Principles */}
        <section className="bg-background-100/70 border-y border-background-200/70">
          <div className="mx-auto w-full max-w-7xl px-4 py-14 md:px-6 md:py-20">
            <div className="mb-8 text-center">
              <span className="inline-flex items-center gap-1.5 rounded-full bg-accent-100 px-3 py-1 text-xs font-medium text-accent-800">
                <i className="ri-honour-line"></i>
                发展理念
              </span>
              <h2 className="mt-3 font-heading text-2xl text-foreground-950 md:text-3xl">
                我们坚持的四条内容原则
              </h2>
            </div>
            <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
              {principles.map((p) => (
                <div
                  key={p.title}
                  className="rounded-2xl border border-background-200/70 bg-background-50 p-6"
                >
                  <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-primary-100 text-primary-600">
                    <i className={`${p.icon} text-xl`}></i>
                  </span>
                  <h3 className="mt-4 font-heading text-lg text-foreground-950">{p.title}</h3>
                  <p className="mt-2 text-sm leading-relaxed text-foreground-600">{p.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Featured works */}
        <section className="mx-auto w-full max-w-7xl px-4 py-14 md:px-6 md:py-20">
          <div className="mb-8 flex flex-col gap-2 sm:flex-row sm:items-end sm:justify-between">
            <div>
              <span className="inline-flex items-center gap-1.5 rounded-full bg-primary-100 px-3 py-1 text-xs font-medium text-primary-700">
                <i className="ri-star-smile-line"></i>
                用户口碑
              </span>
              <h2 className="mt-3 font-heading text-2xl text-foreground-950 md:text-3xl">
                来看看大家怎么说
              </h2>
            </div>
          </div>
          <div className="grid grid-cols-1 gap-4 md:grid-cols-3">
            {testimonials.map((t) => (
              <figure
                key={t.name}
                className="rounded-2xl border border-background-200/70 bg-background-100 p-6"
              >
                <div className="flex items-center gap-1 text-secondary-500">
                  {Array.from({ length: 5 }).map((_, i) => (
                    <i key={i} className="ri-star-fill text-sm"></i>
                  ))}
                </div>
                <blockquote className="mt-4 text-sm leading-relaxed text-foreground-700">
                  “{t.text}”
                </blockquote>
                <figcaption className="mt-5 flex items-center gap-3">
                  <img
                    src={t.avatar}
                    alt={`${t.name}的头像`}
                    title={`${t.name} · 正版韩漫大全用户`}
                    className="h-10 w-10 rounded-full object-cover"
                  />
                  <div>
                    <p className="text-sm font-semibold text-foreground-950">{t.name}</p>
                    <p className="text-xs text-foreground-500">{t.role}</p>
                  </div>
                </figcaption>
              </figure>
            ))}
          </div>
        </section>

        {/* CTA */}
        <section className="mx-auto w-full max-w-7xl px-4 pb-4 md:px-6">
          <div className="rounded-3xl bg-primary-500 px-6 py-12 text-center md:px-10 md:py-16">
            <h2 className="font-heading text-2xl text-background-50 md:text-3xl">
              从今天开始，告别选择困难
            </h2>
            <p className="mx-auto mt-3 max-w-xl text-sm leading-relaxed text-background-100/90">
              前往分类页探索全题材韩漫，或查看人气榜单，找到你的下一部心头好。
            </p>
            <div className="mt-7 flex flex-col items-center justify-center gap-3 sm:flex-row">
              <a
                href="/categories"
                className="inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-background-50 px-6 py-3 text-sm font-semibold text-primary-600 transition-colors hover:bg-background-100"
              >
                <i className="ri-grid-fill"></i>
                浏览题材分类
              </a>
              <a
                href="/rankings"
                className="inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-background-50/15 px-6 py-3 text-sm font-semibold text-background-50 backdrop-blur-sm transition-colors hover:bg-background-50/25"
              >
                <i className="ri-trophy-line"></i>
                查看人气榜单
              </a>
            </div>
          </div>
        </section>

        {/* Contact note */}
        <section className="mx-auto w-full max-w-7xl px-4 py-12 md:px-6">
          <div className="rounded-2xl border border-background-200/70 bg-background-100 p-6 md:p-8">
            <h2 className="font-heading text-xl text-foreground-950 md:text-2xl">联系我们</h2>
            <p className="mt-3 max-w-2xl text-sm leading-relaxed text-foreground-600">
              如果你有内容建议、合作意向或版权相关反馈，欢迎随时与我们联系。我们珍视每一份真诚的建议，也会认真对待每一位读者和创作者的来信。
            </p>
            <div className="mt-5 flex flex-wrap items-center gap-4 text-sm text-foreground-600">
              <a
                href="mailto:hello@manhuadaquan.example.com"
                className="inline-flex items-center gap-2 text-primary-600 transition-colors hover:text-primary-700"
              >
                <i className="ri-mail-line"></i>
                hello@manhuadaquan.example.com
              </a>
              <span className="inline-flex items-center gap-2">
                <i className="ri-time-line"></i>
                内容与榜单每日更新
              </span>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}